






import Vue from 'vue';
import { DetailedEmailCampaign } from '@/types';
import ReportTabs from '@/email-campaign/report/ReportTabs.vue';

export default Vue.extend({
  props: {
    emailCampaign: {
      type: Object as () => DetailedEmailCampaign,
      required: true,
    },
  },
  components: {
    'report-tabs': ReportTabs,
  },
});
